import { AspectRatioKeeper, Image, Typography, Link, omitText } from '@kohler-dsm-library/kohler-core';
import React, { isValidElement } from 'react';
import classes from './ContentCard.module.css.mjs';

const ContentCard = ({ aspectRatio, image, title, description, CTA, isPortrait = false }) => {
  return /* @__PURE__ */ React.createElement("div", { className: classes.contentCard }, /* @__PURE__ */ React.createElement(AspectRatioKeeper, { aspectRatio, className: classes.contentCardFigure }, /* @__PURE__ */ React.createElement(Image, { ...image, position: "absolute", inset: "0" })), /* @__PURE__ */ React.createElement(Typography, { component: title.component || "h3", size: "h5", className: classes.contentCardTitle }, title.text), !isPortrait && description && /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: isValidElement(description.text) ? "div" : description.component || "p",
      size: "paragraph-medium",
      className: classes.contentCardDescription
    },
    description.text
  ), !isPortrait && CTA && /* @__PURE__ */ React.createElement(Link, { size: "medium", className: classes.contentCardLink, ...omitText(CTA) }, CTA.text));
};

export { ContentCard };
